import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import InputMask from 'react-input-mask';
import _ from 'lodash';
import Select from 'react-select';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import * as actions from '../../actions';
import * as c from '../../constant';

function ExportHistoryModal({ handleClose, getReports, getReportList }) {
  const [form, setForm] = React.useState({
    date_from: '',
    date_to: '',
    module_type: '',
  });

  const handleDateChange = key => ({ target: { value } }) => {
    setForm({
      ...form,
      [key]: value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const args = {
      ...form,
      date_from: `${moment(_.get(form, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(form, 'date_to')).format('YYYY-MM-DD')}`,
      module_type: _.get(form, 'module_type') || '',
    };
    getReports(args);

    handleClose();
    setTimeout(() => {
      handleClose();
      const datedToday = {
        // date_from: `${moment(
        //   new Date(date.setMonth(date.getMonth() - 1))
        // ).format('YYYY-MM-DD')}`,
        // date_to: `${moment(new Date(date.setMonth(date.getMonth() + 1))).format(
        //   'YYYY-MM-DD'
        // )}`,
        date_from: `${moment(new Date()).format('YYYY-MM-DD')}`,
        date_to: `${moment(new Date()).format('YYYY-MM-DD')}`,
        type: 'BPLS',
      };
      getReportList(datedToday);
    }, 2000);
  };

  const onClear = e => {
    e.preventDefault();
    setForm({
      date_from: '',
      date_to: '',
      module_type: '',
    });
  };

  const handleSelectChange = key => e => {
    setForm({
      ...form,
      [key]: e ? e.value : '',
    });
  };

  // const onChange = e => {
  //   setForm({
  //     ...form,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  return (
    <form className="mt-5 px-3" onSubmit={handleSubmit}>
      <>
        <div className="d-flex mb-3">
          <h2> Export </h2>
          <button
            onClick={handleClose}
            type="button"
            className="btn btn-link ml-auto"
          >
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="form-input-group mb-2">
          <label className="label-reports font-weight-bold">
            Payment Start Date
          </label>
          <DateInputPicker
            className="full-input"
            withTime
            onChange={handleDateChange('date_from')}
            value={_.get(form, 'date_from') || ''}
            popperPlacement="right-start"
          />
        </div>

        <div className="form-input-group mb-2">
          <label className="label-reports font-weight-bold">
            Payment End Date
          </label>
          <DateInputPicker
            className="full-input"
            withTime
            onChange={handleDateChange('date_to')}
            value={_.get(form, 'date_to') || ''}
            popperPlacement="right-start"
          />
        </div>
        <div className="form-input-group mb-2">
          <label className="label-reports font-weight-bold">Module Type</label>
          <Select
            placeholder="Select Module Type"
            onChange={handleSelectChange('module_type')}
            options={c.BPLS_MODULE_TYPE}
          />
        </div>

        {/* <div className="form-input-group">
          <label className="label-reports font-weight-bold">
            Mobile Number:
          </label>
          <InputMask
            className="form-control"
            mask="999999999999"
            alwaysShowMask
            type="text"
            name="mobile_number"
            onChange={onChange}
            value={_.get(form, 'mobile_number')}
          />
        </div> */}

        <div className="buttons-modal">
          <button
            onClick={onClear}
            type="button"
            className="btn btn-primary font-weight-bold mr-2 btn-dark"
            style={{ width: 150 }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary cms-bg-color-primary font-weight-bold"
            type="submit"
            style={{ width: 150 }}
          >
            <i className="fas fa-download mr-2" /> Export
          </button>
        </div>
      </>
    </form>
  );
}

ExportHistoryModal.propTypes = {
  getReportList: PropTypes.instanceOf(Function).isRequired,
  getReports: PropTypes.instanceOf(Function).isRequired,
  handleClose: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ExportHistoryModal);
